import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./assets/theme";
import store from "./store/store";
import { Provider } from "react-redux";
import {
  AppProvider,
  AuthContextProvider,
  NotificationsProvider,
  LoadingProvider,
} from "./context";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <NotificationsProvider>
          <AuthContextProvider>
            <LoadingProvider>
              <AppProvider>
                <App />
              </AppProvider>
            </LoadingProvider>
          </AuthContextProvider>
        </NotificationsProvider>
      </Provider>
    </ThemeProvider>
  </BrowserRouter>
);
// reportWebVitals();
